'use strict';function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}else{return Array.from(arr)}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const TimeSeries=require('../../../dist-es6/client/utilities/timeSeries');let

FatiguePointExtensions=function(){
function FatiguePointExtensions(self){_classCallCheck(this,FatiguePointExtensions);
this._self=self;
}FatiguePointExtensions.prototype.

withAlertStatusesAndInterpolations=function*withAlertStatusesAndInterpolations(alertThreshold){
if(!this._self){
return;
}

const withStatus=function(point){return _.defaults({status:ThresholdStatus.fromScoreAndThreshold(point.value,alertThreshold)},point)};
const thresholds=_.exists(alertThreshold)?[alertThreshold,alertThreshold-1]:[];
let previousPoint=void 0;

for(const currentPoint of this._self){
if(_.exists(previousPoint)&&previousPoint.time.getTime()!==currentPoint.time.getTime()){

let interpolatedPoints=void 0;

let range;
for(const threshold of thresholds){
range=range||_.sortBy([previousPoint.value,currentPoint.value]);
if(range[0]<threshold&&threshold<range[1]){
interpolatedPoints=(interpolatedPoints||[]).concat(TimeSeries.getInterpolatedPoint(previousPoint,currentPoint,threshold));
}
}

if(interpolatedPoints){
for(const interpolatedPoint of _.sortBy(interpolatedPoints,function(ip){return ip.time.getTime()})){
yield withStatus(interpolatedPoint);
}
}
}

yield withStatus(currentPoint);
previousPoint=currentPoint;
}
};FatiguePointExtensions.prototype.

splitByThresholds=function splitByThresholds(alertThreshold){
const split={
Above:[],
At:[],
BelowOrNotApplicable:[]};


if(!this._self||this._self.length===0){
return split;
}

const withStatuses=[].concat(_toConsumableArray(this.withAlertStatusesAndInterpolations(alertThreshold)));
const warnThreshold=alertThreshold-1;

for(const point of withStatuses){
let naner={time:point.time,value:NaN};
switch(point.status){
case ThresholdStatus.Above:
split.Above.push(point);
split.At.push(point.value===alertThreshold?point:naner);
split.BelowOrNotApplicable.push(naner);
break;
case ThresholdStatus.At:
split.Above.push(naner);
split.At.push(point);
split.BelowOrNotApplicable.push(point.value===warnThreshold?point:naner);
break;
case ThresholdStatus.Below:
case ThresholdStatus.NotApplicable:
split.Above.push(naner);
split.At.push(naner);
split.BelowOrNotApplicable.push(point);
break;}

}

return split;
};FatiguePointExtensions.prototype.

getAlertRangesFor=function getAlertRangesFor(){let threshold=arguments.length>0&&arguments[0]!==void 0?arguments[0]:16;
const alertIntervals=_getFreshAlertIntervals();

if(!this._self||this._self.length===0){
return alertIntervals;
}

const withStatuses=[].concat(_toConsumableArray(this.withAlertStatusesAndInterpolations(threshold)));

const transitions=[withStatuses[0]];

let previousPoint=withStatuses[0];
for(const currentPoint of withStatuses.slice(1)){
if(currentPoint.status!==previousPoint.status){
const transitionPoint=currentPoint.time.getTime()===previousPoint.time.getTime()||currentPoint.value>previousPoint.value?
currentPoint:
{time:previousPoint.time,status:currentPoint.status};

transitions.push(transitionPoint);
transitions.push(transitionPoint);
}
previousPoint=currentPoint;
}

transitions.push(_.last(withStatuses));

for(const[startPoint,endPoint]of _.chunk(transitions,2)){
if(startPoint.time.getTime()!==endPoint.time.getTime()){
alertIntervals[startPoint.status.value].push(TimeInterval.from(startPoint.time).to(endPoint.time));
}
}

return alertIntervals;
};FatiguePointExtensions.prototype.

getAlertRangesOverlapping=function getAlertRangesOverlapping(threshold,intervals){
const visibleAlertRanges=_getFreshAlertIntervals();

if(!intervals||intervals.length===0){
return visibleAlertRanges;
}

const alertRanges=this.getAlertRangesFor(threshold);
for(const thresholdStatus of ThresholdStatusesInDescendingPrecedence){
for(const duty of TimeInterval.compress(intervals)){
const clippedThresholdIntervals=TimeInterval.clip(alertRanges[thresholdStatus]).to(duty);
if(clippedThresholdIntervals.length!==0){
_.pushMany(visibleAlertRanges[thresholdStatus],clippedThresholdIntervals);
}
}
visibleAlertRanges[thresholdStatus]=TimeInterval.compress(visibleAlertRanges[thresholdStatus]);
}

return visibleAlertRanges;
};FatiguePointExtensions.

extend=function extend(fpArray){
return new FatiguePointExtensions(fpArray);
};return FatiguePointExtensions}();


module.exports=FatiguePointExtensions.extend;

const ThresholdStatusesInDescendingPrecedence=['Above','At','Below','NotApplicable'];

const _getFreshAlertIntervals=function(){return{
Above:[],
At:[],
Below:[],
NotApplicable:[]}};
//# sourceMappingURL=fatiguePointExtensions.js.map
